var ChainedMapBase = require('./ChainedMapBase')
var traverse = require('./deps/traverse')
var isTrue = require('./deps/is/true')
var matchFactory = require('./deps/matcher/any-key-val')

var TRAVERSED_KEY = 1
var EXTENSION_KEYS = ['obj', 'keys', 'vals', 'onNonMatch', 'onMatch', 'clone']

/**
 * @since 1.0.0
 * @type {Map}
 * @extends {ChainedMapBase}
 *
 * @memberOf Chainable
 * @member Traverse
 * @see deps/traverse
 * @category traverse
 * @types TraverseChain
 * @tests TraverseChain
 * @symb 👣
 *
 * @prop {Object} obj
 * @prop {Array<Matcher>} [keys]
 * @prop {Array<Matcher>} [vals]
 * @prop {Function} [onMatch]
 * @prop {Function} [onNonMatch]
 * @prop {boolean} [clone]
 */
module.exports = (function (ChainedMapBase) {
  function Traverser(parent) {
    ChainedMapBase.call(this, parent)
    this.call = this.traverse.bind(this)

    /* prettier-ignore */
    this
      .extend(EXTENSION_KEYS)
      .keys([])
      .vals([])
      .onMatch(function (arg, traverser) { return traverser.remove(); })
  }

  if ( ChainedMapBase ) Traverser.__proto__ = ChainedMapBase;
  Traverser.prototype = Object.create( ChainedMapBase && ChainedMapBase.prototype );
  Traverser.prototype.constructor = Traverser;

  /**
   * @desc runs traverser, checks the tests, calls the onMatch
   *       @modifies this.cleaned
   *
   * @alias call
   * @since 1.0.0
   * @param  {boolean} [shouldReturn=false] returns traversed object
   * @return {any} this.obj/data cleaned
   *
   * @memberOf TraverseChain
   *
   * @example
   *
   *   const traversed = new Chain()
   *     .merge({flat: 0, one: {two: true}})
   *     .traverse(false)
   *     .vals([/true/])
   *     .onMatch((current, traverser) => {
   *       traverser.path.join('.')
   *       //=> 'one.two'
   *
   *       current
   *       //=> true
   *
   *       typeof traverser.update === typeof traverser.remove
   *       typeof traverser.update === 'function'
   *       //=> true
   *
   *       traverser.remove()
   *       //=> void
   *     })
   *     .onNonMatch(val => {
   *       // ignore
   *     })
   *     .call(true)
   *
   *   traversed
   *   //=> {flat: 0}
   */
  Traverser.prototype.traverse = function traverse$1 (shouldReturn) {
    var ref = this.entries();
    var obj = ref.obj;
    var keys = ref.keys;
    var vals = ref.vals;
    var onMatch = ref.onMatch;
    var onNonMatch = ref.onNonMatch;
    var clone = ref.clone;
    var result = clone ? traverse(obj).clone() : obj

    // diff between keys and val is order of arg in ^ tester
    var matcher = matchFactory(keys, vals)

    // bound to the traverser
    traverse(obj).forEach(function(x) {
      if (matcher(this.key, x)) {
        onMatch(x, this)
      }
      else if (onNonMatch) {
        onNonMatch(x, this)
      }
    })

    this.set(TRAVERSED_KEY, result)
    return isTrue(shouldReturn) ? result : this
  };

  /**
   * @since 1.0.0
   * @see TraverseChain.traverse
   * @return {Object | Array | any} traversed
   *
   * @example
   *
   *   const traverser = new Traverser()
   *   traverser.obj(['duck', 'duck', 'goose'])
   *   traverser.vals(['g**se'])
   *   traverser.traverse()
   *
   *   traverser.traversed()
   *   // => ['goose']
   *
   * @example
   *
   *    const eh = {
   *      me: true,
   *      nested: {
   *        really: {
   *          deep: {
   *            super: false,
   *            not: 'eh',
   *            canada: true,
   *            modules: [{parser: 'hi'}],
   *          },
   *          matchme: 'minime',
   *          notme: 'eh',
   *        },
   *      },
   *    }
   *
   *    const chain = new Chain()
   *    Object.assign(chain, eh)
   *
   *    const traverser = chain
   *      .merge(eh)
   *      .traverse(true)
   *      .keys([/super/, /parser/, /store/, /meta/])
   *      .vals([/minime/])
   *      .call(false)
   *
   *    traverser.traversed()
   *    // => {
   *      className: 'DotProp',
   *      me: true,
   *      nested: {
   *        really: {
   *          deep: {
   *            not: 'eh',
   *            canada: true,
   *            modules: [{}],
   *          },
   *          notme: 'eh',
   *        },
   *      },
   *    }
   *
   */
  Traverser.prototype.traversed = function traversed () {
    return this.get(TRAVERSED_KEY)
  };

  return Traverser;
}(ChainedMapBase))

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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